module.exports = __webpack_public_path__ + "img/Stanford.fc89c7c1.png";